import React from 'react';
import PropTypes from 'prop-types';
import Script from "next/script"
import DOMPurify from 'isomorphic-dompurify';

class SEOWebsite extends React.PureComponent {
  static propTypes = {
    locale: PropTypes.string.isRequired,
  };

  render() {
    const { locale } = this.props;
    const seoConfig = require(`../../../data/${locale}/seo.json`);
    return (
      <>
        <Script
          id='seo-homepage'
          type="application/ld+json"
          strategy='afterInteractive'
          dangerouslySetInnerHTML={{
            __html:DOMPurify.sanitize( `
            { 
                "@context": "${seoConfig.context}",
                "@type": "WebSite",
                "name": "Pantene",
                "alternateName": "${seoConfig.name}",
                "url": "${seoConfig.url}"
            }`),
          }}
        />
      </>
    );
  }
}

export default SEOWebsite;
